import * as Actions from 'redux/actions'
import { setFocusModeEnabled } from 'redux/actions/focusMode'
import * as AppPreferencesClient from 'api/clients/AppPreferencesClient'
import store from 'redux/store'
import { SidebarTabs } from 'types'
import { ExpandableTree } from 'blaze-components/WorkspaceDashboardSidebar/hooks/useExpandable'
import { uniq } from 'lodash'

export const UserAppPreferencesService = {
  updateActiveTab: (tab: SidebarTabs) => {
    store.dispatch(Actions.setSidebarActiveTab(tab))
  },

  unlockSidebar: () => {
    const currentWorkspaceId = store.getState().workspace.currentWorkspaceId
    const auth = store.getState().auth
    const openFoldersNamespaceKey = `workspace-${currentWorkspaceId}-user-${auth?.id}-tree`
    const openFolderIds = store.getState().openFolderIds[openFoldersNamespaceKey] || []
    const foldersIds = [...openFolderIds, ExpandableTree.Projects]

    store.dispatch(Actions.setSidebarLocked(false))
    store.dispatch(Actions.setOpenFolders(openFoldersNamespaceKey, uniq(foldersIds)))

    if (store.getState().auth) AppPreferencesClient.updateUserAppPreferences({ leftNavLocked: false })
  },

  lockSidebar: () => {
    store.dispatch(Actions.setSidebarLocked(true))
    if (store.getState().auth) AppPreferencesClient.updateUserAppPreferences({ leftNavLocked: true })
  },

  toggleSidebar: () => {
    const {
      sidebar: { locked },
    } = store.getState()

    store.dispatch(Actions.setSidebarLocked(!locked))
    if (store.getState().auth) AppPreferencesClient.updateUserAppPreferences({ leftNavLocked: !locked })
  },

  setFocusModeEnabled: (value: boolean) => {
    store.dispatch(setFocusModeEnabled({ enableFocusMode: value }))
    AppPreferencesClient.updateUserAppPreferences({ focusModeDisabled: !value })
  },
}
